import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import BernoulliHome from './BernoulliHome/BernoulliHome';
import AutodeskAssistant from './AutodeskAssistant/AutodeskAssistant';
import AssistantIcon from '@/components/icons/AssistantIcon';

export const AUTODESK_ASSISTANT_PATH = '/autodesk-assistant';

const autodeskAssistantRoute = {
  title: 'Autodesk Assistant',
  to: AUTODESK_ASSISTANT_PATH,
  icon: <AssistantIcon />,
  render: <BernoulliHome />,
};

const embeddedAssistantRoute = {
  title: 'Autodesk Assistant (Embedded)',
  to: '/autodesk-assistant-embed',
  icon: <AssistantIcon />,
  render: <AutodeskAssistant />,
};

export function usePageRoutes() {
  const isEmbeddedAssistantEnabled = useIsFeatureEnabled(
    'info360-embed-autodesk-assistant',
  );

  return useMemo(() => {
    const routes = [autodeskAssistantRoute];
    if (isEmbeddedAssistantEnabled) {
      routes.push(embeddedAssistantRoute);
    }
    return routes;
  }, [isEmbeddedAssistantEnabled]);
}

// Nav-shaped entries only — these legacy exports are consumed by the host shell.
const pageRoutes = [autodeskAssistantRoute];

// Legacy export for backward compatibility
export const miniPageRoutes = pageRoutes;
export default pageRoutes;
